import { create } from "zustand";

interface LayoutStore {
  isReportPanelFullscreen: boolean;
  setReportPanelFullscreen: (fullscreen: boolean) => void;
  toggleReportPanelFullscreen: () => void;
}

export const useLayoutStore = create<LayoutStore>()((set) => ({
  isReportPanelFullscreen: false,
  setReportPanelFullscreen: (fullscreen) =>
    set({ isReportPanelFullscreen: fullscreen }),
  toggleReportPanelFullscreen: () =>
    set((s) => ({ isReportPanelFullscreen: !s.isReportPanelFullscreen })),
}));
